import { useState } from 'react'

import { Jobsite } from 'InstitutionalManagement/types'
import getJobsiteOnCustomForm from './services/getJobsiteOnCustomForm'

export default function useGetJobsiteByID() {
  const [loadingJobsite, setLoadingJobsite] = useState<boolean>(false)
  const [jobsite, setJobsite] = useState<Jobsite>({})

  async function getJobsite(jobsiteId?: string) {
    setLoadingJobsite(true)
    const response = await getJobsiteOnCustomForm({ jobsiteId: jobsiteId as string })
    let jobsiteFromAPI: Jobsite = {}
    if (response?.header?.success) {
      jobsiteFromAPI = response?.body?.jobsite
      setJobsite(jobsiteFromAPI)
    }
    setLoadingJobsite(false)
    return jobsiteFromAPI
  }

  return { getJobsite, jobsite, loadingJobsite }
}
